module.exports = __webpack_public_path__ + "static/media/about-certificate-img11.517dc5b2.jpg";